import { createFileRoute, redirect } from "@tanstack/react-router";
import { sessionActions } from "@/features/auth/session";
import { WorkspaceGuard } from "@/features/auth/WorkspaceGuard";

export const Route = createFileRoute("/app/tenant")({
  beforeLoad: async () => {
    const s = await sessionActions.whenSettled();
    // Tenant pages are scoped to the signed-in admin's own tenant and
    // distribution (same rule as the workspace switcher); operators manage
    // tenants from the operator workspace.
    if (!s.persona.isTenantAdmin) throw redirect({ to: "/app/forbidden" });
  },
  component: () => <WorkspaceGuard allow={(p) => p.isTenantAdmin} />,
});
